var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconJustifyParagraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 5h26a1 1 0 0 0 0-2h-26a1 1 0 0 0 0 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15 27h-12a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m29 9h-26a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m29 15h-26a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m29 21h-26a1 1 0 0 0 0 2h26a1 1 0 0 0 0-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJustifyParagraph);
export default __webpack_public_path__ + "static/media/icon-justify-paragraph.6eb3c9fe138afef560facb199a5ec343.svg";
export { ForwardRef as ReactComponent };